<div id="breadcrumb">

    <div class="container">

        <div class="breadcrumb-wrapper">

            <h1> Contact Us </h1>

            <ul>
                <li>
                    <a href="#"> Home </a>
                </li>

                <li>
                    <i class="bi bi-chevron-double-right"></i>
                </li>

                <li>
                    <a href="#"> Contact </a>
                </li>

            </ul>

        </div>

    </div>

</div>


<div class="contact-info">

    <div class="container">

        <div class="row">

            <div class="col-md-4">

                <div class="contact-box">

                    <div class="icon">
                        <i class="bi bi-map-fill"></i>
                    </div>

                    <div class="text">
                        <h4> Address </h4>
                        <p> 91 Western Road, Brighton, England </p>
                    </div>

                </div>

            </div>

            <div class="col-md-4">

                <div class="contact-box">

                    <div class="icon">
                        <i class="bi bi-telephone-fill"></i>
                    </div>

                    <div class="text">
                        <h4> Phone </h4>
                        <p> +44 1632 960896 </p>
                    </div>

                </div>

            </div>

            <div class="col-md-4">

                <div class="contact-box">

                    <div class="icon">
                        <i class="bi bi-envelope-fill"></i>
                    </div>

                    <div class="text">
                        <h4> Email </h4>
                        <p> securityrelated@securityrelated.com</p>
                    </div>

                </div>

            </div>

        </div>

    </div>

</div>

<div class="contact-form">

    <div class="container-fluid">

        <div class="row">

            <div class="col-lg-6 col-md-12">

                <div class="row px-lg-4 px-md-4">

                    <div class="col-lg-6 col-md-6 col-sm-6 col-6 px-lg-3 p-md-3 p-sm-3 p-3">
                        <input type="text" name="name" placeholder="First Name" class="form-control"
                            [(ngModel)]="viewModel.singleContact.firstName">
                           
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-6 col-6 px-lg-3 p-md-3 p-sm-3 p-3">
                        <input type="text" name="name" placeholder="Last Name" class="form-control"
                        [(ngModel)]="viewModel.singleContact.lastName" >
                            
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-6 col-6 p-lg-3 p-md-3 p-sm-3 p-3">
                        <input type="email" name="email" placeholder="Email Address" class="form-control"
                        [(ngModel)]="viewModel.singleContact.email"  >
                           
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-6 col-6 p-lg-3 p-md-3 p-sm-3 p-3">
                        <input type="number" name="phone" placeholder="Phone Number" class="form-control"
                        [(ngModel)]="viewModel.singleContact.contactNumber"   >
                           
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 p-lg-3 p-md-3 p-sm-3 p-3">
                        <textarea rows="5" placeholder="Message" class="form-control"
                        [(ngModel)]="viewModel.singleContact.contactMessage"   > </textarea>
                           
                    </div>

                    <div class="col-md-12 px-lg-3 text-end">
                        <button type="submit" class="contact-button" (click)="sendContactUsForm()"> Submit </button>
                    </div>

                </div>

            </div>

            <div class="col-lg-6 col-md-12">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d233667.82239086815!2d90.27923710646989!3d23.780887457084543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b8b087026b81%3A0x8fa563bbdd5904c2!2sDhaka!5e0!3m2!1sen!2sbd!4v1611940939806!5m2!1sen!2sbd"
                    width="100%" height="375" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false"
                    tabindex="0">
                </iframe>
            </div>

        </div>

    </div>

</div>


<footer id="footer">
    <div class="container">
        <div class="row">

            <!-- About Section -->
            <div class="col-md-6 col-lg-3">
                <div class="about">
                    <img class="logo" src="assets/icons/Transparent-2.png" alt="iTech Logo">
                    <p>
                        iTech is a leading IT solutions and consultancy provider, helping businesses
                        innovate, streamline operations, and achieve sustainable growth. From
                        software development to cloud transformation, we deliver secure, scalable,
                        and tailored solutions to meet your unique business needs.
                    </p>
                    <div class="social-icon">
                        <a href="#"><i class="bi bi-facebook"></i></a>
                        <a href="#"><i class="bi bi-twitter"></i></a>
                        <a href="#"><i class="bi bi-instagram"></i></a>
                    </div>
                </div>
            </div>

            <!-- Quick Links -->
            <div class="col-md-6 col-lg-3">
                <div class="quick-link">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a href="#">Product Design</a></li>
                        <li><a href="#">Application Development</a></li>
                        <li><a href="#">Cyber Security</a></li>
                        <li><a href="#">Data Quality Management</a></li>
                        <li><a href="#">IT Consultancy</a></li>
                        <li><a href="#">Mobile Development</a></li>
                        <li><a href="#">Cloud Migration</a></li>
                    </ul>
                </div>
            </div>

            <!-- Address -->
            <div class="col-md-6 col-lg-3">
                <div class="address">
                    <h4>Our Address</h4>
                    <img src="assets/images/img-footer-map.png" alt="Map">
                    <p>
                        <i class="bi bi-geo-alt-fill"></i>
                        <span>91 Western Road, Brighton, England</span>
                    </p>
                </div>
            </div>

            <!-- Contact Info -->
            <div class="col-md-6 col-lg-3">
                <div class="contact">
                    <h4>Contact Us</h4>

                    <div class="phone">
                        <p>
                            <i class="bi bi-telephone-fill"></i>
                            <a href="tel:+441632960896">+44 1632 960896</a>
                        </p>
                    </div>

                    <div class="email">
                        <p>
                            <i class="bi bi-envelope-fill"></i>
                            <a href="mailto:info@itech.com">info@itech.com</a>
                        </p>
                    </div>

                    <div class="subscribe">
                        <p>Subscribe to our Newsletter</p>
                        <form action="#">
                            <input type="email" placeholder="Your email" required>
                            <button type="submit"><i class="bi bi-arrow-right"></i></button>
                        </form>
                    </div>
                </div>
            </div>

        </div>

        <!-- Copyright -->
        <div class="copyright">
            <div class="left">
                <p>Copyright © 2025 iTech. All rights reserved.</p>
            </div>
            <div class="copyright-menu">
                <ul>
                    <li><a href="#">Terms & Condition</a></li>
                    <li><a href="#">Privacy Policy</a></li>
                    <li><a href="#">Contact Us</a></li>
                </ul>
            </div>
        </div>

    </div>
</footer>
